import { FC } from 'react';
import dayjs from 'dayjs';

import QuestionMark from 'components/QuestionMark/QuestionMark';
import MyStoreSyncProductsBtn from 'components/Settings/MyStoreTab/MyStoreSyncProductsBtn';
import { selectAccountSettingsMeta, selectStoreSettings } from 'store/selectors/settingsSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { momentFormats, questionMarks } from 'utils/constants/constants';

const MyStoreSync: FC = () => {
  const { productsSyncDate } = useTypedSelector(selectStoreSettings);
  const { isStoreConnected } = useTypedSelector(selectAccountSettingsMeta);

  if (!isStoreConnected) {
    return null;
  }

  return (
    <>
      <h4 className="mt-8">
        Store Synchronization
        <QuestionMark>{questionMarks.store.storeSync}</QuestionMark>
      </h4>
      <div
        className="flex items-center justify-between p-4 mt-5 border border-black-20 rounded-lg dark:border-black-80"
      >
        <div>
          <p>Store Products Synchronization</p>
          <p className="font-regular">
            Last synchronizing date:
            {productsSyncDate ? dayjs(productsSyncDate).format(momentFormats.withTime) : '-'}
          </p>
        </div>
        <MyStoreSyncProductsBtn type="default" />
      </div>
    </>
  );
};

export default MyStoreSync;
